import { api } from "@/lib/api";

const toBytes = (v) => {
  const b = atob((v + "=".repeat((4 - (v.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(b, (c) => c.charCodeAt(0));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const pushStatus = async () => {
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  const reg = await navigator.serviceWorker.getRegistration("/");
  const sub = await reg?.pushManager.getSubscription();
  return sub && Notification.permission === "granted" ? "on" : "off";
};

export async function enablePush() {
  if (!pushSupported()) throw new Error("Perangkat ini belum mendukung notifikasi. Di iPhone, pasang aplikasi ke Layar Utama dulu.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Izin notifikasi tidak diberikan");
  const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  const sub = (await reg.pushManager.getSubscription())
    || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.public_key) }));
  const j = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: j.endpoint, keys: j.keys });
}

export async function syncPush() {
  if ((await pushStatus()) !== "on") return;
  const reg = await navigator.serviceWorker.getRegistration("/");
  const j = (await reg.pushManager.getSubscription()).toJSON();
  await api.post("/push/subscribe", { endpoint: j.endpoint, keys: j.keys }).catch(() => {});
}

const SOUND_KEY = "cu-notif-sound";
export const SOUNDS = [
  { id: "lonceng", label: "Lonceng", notes: [[880, 0], [1320, 0.18]], wave: "sine" },
  { id: "koin", label: "Koin", notes: [[988, 0], [1319, 0.09], [1760, 0.18]], wave: "square", gain: 0.12 },
  { id: "lembut", label: "Lembut", notes: [[523, 0], [659, 0.22], [784, 0.44]], wave: "triangle" },
  { id: "off", label: "Tanpa Suara", notes: [] },
];
export const getSound = () => localStorage.getItem(SOUND_KEY) || "lonceng";
export const setSound = (id) => localStorage.setItem(SOUND_KEY, id);

export function playChime(id = getSound()) {
  const s = SOUNDS.find((x) => x.id === id) || SOUNDS[0];
  if (!s.notes.length) return;
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    s.notes.forEach(([f, d]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      const t = ctx.currentTime + d;
      o.type = s.wave;
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(s.gain || 0.35, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
      o.connect(g).connect(ctx.destination);
      o.start(t);
      o.stop(t + 0.4);
    });
    navigator.vibrate?.([120, 60, 120]);
  } catch {
    /* audio unavailable */
  }
}
